import { useState } from 'react';
import {
  Paper,
  TextInput,
  PasswordInput,
  Button,
  Text,
  Stack,
  Alert,
  Center,
  Box,
} from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from '@/contexts/AuthContext';

export function LoginPage() {
  const navigate = useNavigate();
  const { login, isLoading } = useAuthContext();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setIsSubmitting(true);

    const result = await login({ username, password });

    if (result.success) {
      navigate('/devices');
    } else {
      setError(result.error || 'Login failed');
    }

    setIsSubmitting(false);
  };

  if (isLoading) {
    return (
      <Center h="100vh">
        <Text>Loading...</Text>
      </Center>
    );
  }

  return (
    <Center h="100vh" bg="gray.1">
      <Paper shadow="md" p="xl" w={400} radius="md">
        <Stack gap="lg">
          <Center>
            <Box>
              <Center mb="md">
                <img src="/logo.svg" alt="DeploySense" height={60} style={{ objectFit: 'contain' }} />
              </Center>
              <Text c="dimmed" size="sm" ta="center">
                IT Asset & Device Management
              </Text>
            </Box>
          </Center>

          {error && (
            <Alert icon={<IconAlertCircle size={16} />} color="red" variant="light">
              {error}
            </Alert>
          )}

          <form onSubmit={handleSubmit}>
            <Stack gap="md">
              <TextInput
                label="Username"
                placeholder="Enter your username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                autoFocus
              />
              <PasswordInput
                label="Password"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <Button type="submit" fullWidth loading={isSubmitting}>
                Sign In
              </Button>
            </Stack>
          </form>
        </Stack>
      </Paper>
    </Center>
  );
}
